export const formatDate = (date: string): string => {
    // Convertimos la fecha ISO a un formato solo de fecha, sin la parte después de la T
    return date.split('T')[0]; // Devuelve solo la parte antes de la T (YYYY-MM-DD)
  };
  